module.exports = __webpack_public_path__ + "assets/1.335abb98.png";